import { supabase } from "~/integrations/supabase/client";

export interface ClosedPeriod {
  id: string;
  year: number;
  month: number;
  is_closed: boolean;
  closed_by: string | null;
  closed_at: string | null;
  created_at: string;
}

export const closedPeriodService = {
  async getAll(): Promise<ClosedPeriod[]> {
    const { data, error } = await supabase
      .from("accounting_closed_periods")
      .select("*")
      .eq("is_closed", true)
      .order("year", { ascending: false })
      .order("month", { ascending: false });

    if (error) throw error;
    return data as ClosedPeriod[];
  },

  async isMonthClosed(year: number, month: number): Promise<boolean> {
    const { data, error } = await supabase
      .from("accounting_closed_periods")
      .select("is_closed")
      .eq("year", year)
      .eq("month", month)
      .maybeSingle();

    if (error) throw error;
    return data?.is_closed ?? false;
  },

  async closePeriod(
    year: number,
    month: number,
    closedBy: string
  ): Promise<ClosedPeriod> {
    const { data, error } = await supabase
      .from("accounting_closed_periods")
      .upsert(
        {
          year,
          month,
          is_closed: true,
          closed_by: closedBy,
          closed_at: new Date().toISOString(),
        },
        { onConflict: "year,month" }
      )
      .select()
      .single();

    if (error) throw error;
    return data as ClosedPeriod;
  },

  async reopenPeriod(year: number, month: number): Promise<void> {
    const { error } = await supabase
      .from("accounting_closed_periods")
      .update({ is_closed: false })
      .eq("year", year)
      .eq("month", month);

    if (error) throw error;
  },
};
